import { StoreWallInterface } from "../../types/store";

export const updateItem = (shelving: StoreWallInterface, id: string, sectionID: string) => {
    const sections = structuredClone(shelving.sections);
    if (!shelving.itemsYPos) {
        return sections
    };

    const currentSectionIndex = sections.findIndex((section) => section.id === sectionID);
    const currentShelf = sections[currentSectionIndex].items.find((item) => item.id === id);

    if (!currentShelf) return;

    const newSectionIndex = sections.findIndex((section) => section.id === currentShelf.sectionID);

    if (currentSectionIndex < 0 || newSectionIndex < 0) return;
    if (sections[newSectionIndex].width !== currentShelf.width && (currentShelf.width < 1000)) return;

    if (currentSectionIndex !== newSectionIndex) {
        sections[currentSectionIndex].items = sections[currentSectionIndex].items.filter((item) => item.id !== id);
        sections[newSectionIndex].items.push(currentShelf);
    }
    return sections
};
